export const workoutRequestQueryKeys = {
  all: (): string => "workout-request",
  listByHorse: (horseId?: string): string =>
    `workout-request:list:horse:${horseId}`
};
